/**
 * Format Zod validation errors for server action responses.
 *
 * Reduces a ZodError's issues into a flat record of field name → message,
 * suitable for returning to the client from a server action.
 *
 * @module utils/formatted-errors
 */
import type { ZodError } from "zod";

export const formattedErrors = ({
  validationError,
}: {
  validationError: ZodError;
}) =>
  validationError.issues.reduce(
    (acc: Record<string, string>, error) => {
      const fieldName = error.path[0] as string;
      acc[fieldName] = error.message;
      return acc;
    },
    {} as Record<string, string>,
  );
